
export const getOldProfileSummary = (themeData, profileData) => {
    const {
        profile_defaults: {
            professional_summary: defaultProfileSummary
        } = {}
    } = themeData;
    const {
        professional_summary: profileSummary
    } = profileData;

    return profileSummary || defaultProfileSummary;
};

export const getNewProfileSummary = (themeData, profileData) => {
    const {
        new_profile_summary_default_list: defaultProfileSummaryList = []
    } = themeData;
    const {
        new_profile_summary_custom: customProfileSummary,
        new_profile_summary_dropdown: [selectedProfileSummaryName] = []
    } = profileData;
    const [{ value: defaultProfileSummary } = {}] =
        defaultProfileSummaryList.filter(({ name }) => (name === selectedProfileSummaryName));

    const [{ value: firstElementOfDefaultProfileSummaryList } = {}] = defaultProfileSummaryList;

    return customProfileSummary || defaultProfileSummary || firstElementOfDefaultProfileSummaryList;
};

export const getProfileSummaryFromSiteData = (themeData, profileData) => {
    const {
        is_new_profile_summary_enabled: [
            isNewProfileSummaryEnabled
        ] = []
    } = themeData;

    return isNewProfileSummaryEnabled === 'true'
        ? getNewProfileSummary(themeData, profileData)
        : getOldProfileSummary(themeData, profileData);
};



// WEBPACK FOOTER //
// ./components/profile/profile_utils.js